var _path, _defs, _clipPath, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _radialGradient, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChromeStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 139,
    viewBox: "0 0 192 192",
    width: 139,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h192v192H0z",
    fill: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 20v140c0 6.6 5.4 12 12 12h152c6.6 0 12-5.4 12-12V20H8zm108 32H76c-4.42 0-8-3.58-8-8s3.58-8 8-8h40c4.42 0 8 3.58 8 8s-3.58 8-8 8z",
    id: "a"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#a"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "M8 20h176v152H8z",
    fill: "#eee"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "M116 36H76c-4.42 0-8 3.58-8 8s3.58 8 8 8h40c4.42 0 8-3.58 8-8s-3.58-8-8-8z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 160,
    id: "c",
    r: 76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    d: "M32.07 84v93.27h34.01L96 125.45h76V84zm0 0v93.27h34.01L96 125.45h76V84z",
    fill: "#DB4437"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    d: "M20 236h72.34l33.58-33.58v-25.14l-59.84-.01L20 98.24zm0 0h72.34l33.58-33.58v-25.14l-59.84-.01L20 98.24z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    d: "M96 125.45l29.92 51.82L92.35 236H172V125.45zm0 0l29.92 51.82L92.35 236H172V125.45z",
    fill: "#FFCD40"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 160,
    fill: "#F1F1F1",
    r: 34.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 160,
    fill: "#4285F4",
    r: 27.64
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "M8 20h176v76H8z",
    fill: "#212121",
    fillOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 95h176v1H8z",
    fill: "#212121",
    fillOpacity: 0.02
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 96h176v1H8z",
    fill: "#fff",
    fillOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116 52H76c-4.25 0-7.72-3.32-7.97-7.5-.02.17-.03.33-.03.5 0 4.42 3.58 8 8 8h40c4.42 0 8-3.58 8-8 0-.17-.01-.33-.03-.5-.25 4.18-3.72 7.5-7.97 7.5zM8 20v1h176v-1H8z",
    fill: "#212121",
    fillOpacity: 0.02
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76 36h40c4.25 0 7.72 3.32 7.97 7.5.01-.17.03-.33.03-.5 0-4.42-3.58-8-8-8H76c-4.42 0-8 3.58-8 8 0 .17.01.33.03.5.25-4.18 3.72-7.5 7.97-7.5zm96 135H20c-6.6 0-12-5.4-12-12v1c0 6.6 5.4 12 12 12h152c6.6 0 12-5.4 12-12v-1c0 6.6-5.4 12-12 12z",
    fill: "#231F20",
    fillOpacity: 0.1
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    cx: 7.502,
    cy: 19.344,
    gradientUnits: "userSpaceOnUse",
    id: "e",
    r: 227.596
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20v140c0 6.6 5.4 12 12 12h152c6.6 0 12-5.4 12-12V20H8zm108 32H76c-4.42 0-8-3.58-8-8s3.58-8 8-8h40c4.42 0 8 3.58 8 8s-3.58 8-8 8z",
    fill: "url(#e)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeStore);
export default __webpack_public_path__ + "static/media/chrome_store.0c9434d88ec9858a88a9b7ca2e37c6fd.svg";
export { ForwardRef as ReactComponent };